import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { Mixpanel } from "../../helpers";

function ListView(props) {

  const { dealjacket, deal_jacket_id, toggleCarousel, setCurrentPageIndex, setCurrentJacketPages, authentication, org } = props;
  const jwt = authentication.jwt;
  const user_id = authentication?.user?.user_id;
  const org_id = org?.current_org_id;
  const current_org = org.list?.filter(
    (o) => o.org_id == org_id
  )[0];
  const limit_pipeline = current_org?.limit_pipeline;

  useEffect(() => {
    const custom_properties = {
      'tt_user_id': user_id,
      'tt_org_id': org_id,
      'tt_deal_jacket_id': deal_jacket_id
    };
    Mixpanel.track('ListView', custom_properties);
  }, [deal_jacket_id, org_id, user_id]);



  const headers = ["image", "group", "page type"];

  const tableHeaders = headers.map((header, i) => <th key={header}>&nbsp;&nbsp;&nbsp;{header}</th>);

  const tableRows = dealjacket?.map((page, i) => (
    <tr key={page.group_id + ":" + page.page_id}>
      <td>
        <img
          className="pageImage"
          src={page?.image_path + "?t=" + jwt}
          loading="lazy"
          alt={page.page_id}
          width="51"
          height="66"
          onClick={() => {
            const pageIndex = dealjacket.findIndex(
              (p) => p.page_id === page.page_id
            );
            setCurrentJacketPages(dealjacket);
            setCurrentPageIndex(pageIndex);
            toggleCarousel();
          }}
        />
      </td>
      {
        (!limit_pipeline) &&
        <>
          <td>{page.page_group_name}</td>
          <td>{page.page_type_name}</td>
        </>
      }

    </tr>
  ));

  return (
    <table align="center" className="paleBlueRows">
      <thead>
        <tr>
          {tableHeaders}
        </tr>
      </thead>
      <tbody>
        {tableRows}
      </tbody>
    </table>
  )

}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org
  };
}

const connectedListView = connect(mapStateToProps)(
  ListView
);
export { connectedListView as ListView };